import React, { useMemo } from "react";
import { Grid as GridBase, Paper } from "@mui/material";
import ConfirmLocationItem from "@/features/campaigns/components/ConfirmLocationItem";
import { CurrencyFormateText } from "@/components/CurrencyFormat";
import { getChannelIcons, getFormatDate } from "@/helpers/utils";

type BoostChannel = {
  id: number | string;
  label: string;
};

export type BoostSelection = {
  locationId?: number | string;
  locationInfo?: {
    location_name?: string;
  } | null;
  boost_budget?: string | number | null;
  start_date?: string | Date | null;
  end_date?: string | Date | null;
  channels: Array<number | string>;
};

type BoostConfirmLocationProps = {
  loc?: BoostSelection | null;
  channelsList?: BoostChannel[];
  campaignHasOnlyPMaxChannel?: boolean;
  total?: number;
};

const Grid = GridBase as React.ComponentType<Record<string, any>>;
const getTypedChannelIcons = getChannelIcons as {
  (_channels: string[]): React.ReactNode;
};

function BoostConfirmLocation({
  loc,
  channelsList = [],
  campaignHasOnlyPMaxChannel,
  total,
}: BoostConfirmLocationProps) {
  const {
    locationInfo,
    boost_budget,
    // current_budget,
    start_date,
    end_date,
    channels,
  } = loc || {};

  const { location_name } = locationInfo || {};

  const renderChannels = useMemo(() => {
    const chArr = (channels as Array<number | string>)
      .map((c) => {
        const channelDetail = channelsList.find((ch) => ch.id === c);
        return channelDetail!.label;
      })
      ?.sort();
    return getTypedChannelIcons(chArr);
  }, [channelsList, channels]);

  return (
    <Paper className="my-3 px-2" elevation={2}>
      <Grid container spacing={2} justifyContent="space-between">
        <Grid item size={{ xs: 12, md: 2 }} className="p-2">
          <ConfirmLocationItem
            svgIcon="location_mark"
            label="Location"
            value={campaignHasOnlyPMaxChannel ? "All Locations" : location_name}
          />
        </Grid>
        <Grid item size={{ xs: 6, md: 2 }} className="p-2">
          <ConfirmLocationItem
            svgIcon="month_calender"
            label="Start Date"
            value={getFormatDate(start_date)}
          />
        </Grid>
        <Grid item size={{ xs: 6, md: 2 }} className="p-2">
          <ConfirmLocationItem
            svgIcon="month_calender"
            label="End Date"
            value={getFormatDate(end_date)}
          />
        </Grid>
        {/* <Grid item xs={6} md={2}>
          <ConfirmLocationItem
            imgSrc="/img/icons/wallet.svg"
            label="Current Budget"
            value={<CurrencyFormateText value={current_budget} suffix=" USD" />}
          />
        </Grid> */}
        <Grid item size={{ xs: 6, md: 2 }} className="p-2">
          <ConfirmLocationItem
            svgIcon="wallet"
            label="Budget"
            value={
              <CurrencyFormateText
                value={campaignHasOnlyPMaxChannel ? total : boost_budget}
                suffix=" USD"
              />
            }
            valueProps={{
              color: "primary",
            }}
          />
        </Grid>
        <Grid item size={{ xs: 6, md: 2 }} className="p-2">
          <ConfirmLocationItem
            svgIcon="images"
            label="Type"
            value={renderChannels}
          />
        </Grid>
      </Grid>
    </Paper>
  );
}

export default BoostConfirmLocation;
